<template>
   <div class="leads-page">
      <div class="mt-3">
         <Proposals/>
      </div>
   </div>
</template>

<script>
import Proposals from '@/components/Proposals/ProposalsDashboard.vue';

export default {

   components: {
       Proposals,
   },

}
</script>